import { css } from "@emotion/react";
import { kitText } from "../../styles";

export const styles = {
  wrapper: css`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: auto;
    appearance: none;
    user-select: none;
    position: relative;
    white-space: nowrap;
  `,
  crumb: css`
    color: var(--color-tertiary);
    font-size: var(--font-size-12);
    line-height: var(--spacing-16);
    cursor: pointer;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: var(--spacing-4);
    &:hover {
      text-decoration: none;
      color: var(--color-splash-primary);
    }
  `,
  unclickableCrumb: css`
    pointer-events: none;
  `,
  currentCrumb: css`
    color: var(--color-primary);
    pointer-events: none;
  `,
  variant: {
    stepper: css`
      ${kitText.variant.body}
      color: var(--color-primary);
      ${kitText.style.bold}
    `
  },
  stepperSeparator: css`
    height: 2px;
    width: var(--spacing-8);
    display: block;
    margin: 0 var(--spacing-8);
    background-color: var(--color-tertiary);
  `
};
